































































import Vue from 'vue'
import Modal from '@/pmd/components/common/Modal.vue'
import PhoneNumber from '../util/PhoneNumber.vue'

export default Vue.extend({
  props: ['phone', 'loader', 'modalShow'],
  components: {
    PhoneNumber,
    Modal,
  },
  data() {
    return {
      popupWidth: 500,
      cellNumber: this.phone,
      incomingPhoneNumbers: [] as Array<{ [key: string]: any }>,
    }
  },
  mounted() {
    this.cellNumber = this.phone
  },
  watch: {
    phone: function (phone) {
      this.cellNumber = phone
    },
  },
  methods: {
    closeModal() {
      this.$root.$emit('close-modal')
    },
    async savePhoneAndSendLink() {
      let result = await this.$validator.validateAll('form-subaccount')
      if (!result) {
        return false
      }
      this.$root.$emit('send-link', this.cellNumber)
    },
  },
})
